import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Download, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../lib/metaPixel';
export const FinalCtaSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-warmcream text-center" data-id="element-27">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-29">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-emerald leading-tight mb-8" data-id="element-30">
            Tu bienestar puede empezar hoy.
          </h2>

          <p className="text-xl text-brand-charcoal mb-12 max-w-2xl mx-auto" data-id="element-31">
            No tienes que seguir viviendo con cansancio, estrés y la sensación
            de que tu cuerpo trabaja en tu contra. Da el primer paso con una
            guía práctica de 21 días diseñada para ayudarte a construir hábitos
            que favorezcan un mejor descanso, más energía y un mayor bienestar.
          </p>

          <a href="https://pay.hotmart.com/L105883257P" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
          content_name: 'Resetea tu Cortisol en 21 Días',
          value: 9.99,
          currency: 'USD'
        })} className="inline-block w-full sm:w-auto px-10 py-5 text-xl font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 mb-6" data-id="element-32">
            QUIERO MI GUÍA AHORA — $9.99
          </a>

          <p className="italic text-center mx-auto mt-2 mb-8" style={{
          fontSize: '12px',
          color: '#6B7280',
          maxWidth: '500px'
        }} data-id="element-33">
            ⚕️ El contenido de esta guía es informativo y educativo. No
            reemplaza ni sustituye el consejo, diagnóstico o tratamiento médico
            profesional. Consulta siempre a tu médico ante cualquier duda sobre
            tu salud.
          </p>

          <div className="flex flex-wrap justify-center gap-6 sm:gap-10 text-sm font-medium text-gray-600" data-id="element-34">
            <div className="flex items-center gap-2" data-id="element-35">
              <Download className="w-5 h-5 text-brand-emerald" data-id="element-36" />
              <span data-id="element-37">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-38">
              <Lock className="w-5 h-5 text-brand-emerald" data-id="element-39" />
              <span data-id="element-40">Pago 100% seguro con Hotmart</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-41">
              <ShieldCheck className="w-5 h-5 text-brand-emerald" data-id="element-42" />
              <span data-id="element-43">Acceso de por vida</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};